import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionTypeArrowIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.4375 16.2647L8.4375 3.8897L9.5625 3.8897L9.5625 16.2647L8.4375 16.2647Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.2499 9.7477L8.99992 4.4977L3.74992 9.7477L2.95442 8.9522L7.40893 4.4977C8.2876 3.61902 9.71223 3.61902 10.5909 4.4977L15.0454 8.9522L14.2499 9.7477Z",
		fill: "black"
	})]
});
export default SvgTransactionTypeArrowIcon;
